define('app/sdc/wizard/controls/sdc-wizard-controls',[],function () {
	return {
		require: {
			"wizard": "^sdc-wizard.public"
		},
		transclude: true,
		controller: {
		}
	};
});
